import { render, staticRenderFns } from "./OrganisationsCreateModal.vue?vue&type=template&id=68985619&"
import script from "./OrganisationsCreateModal.vue?vue&type=script&lang=js&"
export * from "./OrganisationsCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports